/**
 *
 */
import { get, post, del,downloadImg,upload } from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

//詳細
export const getApp = (clientId) => new Promise((resolve, reject) => {
    get(config.DESIGN_APP+clientId)
        .then(function (response) {
            resolve(response)
        }).catch(function (error) {
            reject(error);
        })
})
export const getWeb = (clientId) => new Promise((resolve, reject) => {
    get(config.DESIGN_WEB+clientId)
        .then(function (response) {
            resolve(response)
        }).catch(function (error) {
            reject(error);
        })
})
//保存
export const saveApp = (param) => new Promise((resolve, reject) => {
    post(config.DESIGN_APP_SAVE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})
export const saveWeb = (param) => new Promise((resolve, reject) => {
    post(config.DESIGN_WEB_SAVE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})

//削除
export const delApp = (clientId) => new Promise((resolve, reject) => {
    del(config.DESIGN_APP+clientId)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
        })
})
export const delWeb = (clientId) => new Promise((resolve, reject) => {
    del(config.DESIGN_WEB+clientId)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
        })
})

export const logoUpload = (param) => new Promise((resolve, reject)=> {
    upload(config.DESIGN_LOGO_UPLOAD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
    })
})

//get image
export const logoDown = (fileUuid) => new Promise((resolve, reject)=> {
    downloadImg(config.DESIGN_LOGO_DOWNLOAD+fileUuid)
        .then(res => {
            return 'data:image/png;base64,' + btoa(
                new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})


export const backImageUpload = (param) => new Promise((resolve, reject)=> {
    upload(config.DESIGN_BODYBACKIMAGE_UPLOAD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
    })
})

//get image
export const backImageDown = (fileUuid) => new Promise((resolve, reject)=> {
    downloadImg(config.DESIGN_BODYBACKIMAGE_DOWNLOAD+fileUuid)
        .then(res => {
            return 'data:image/png;base64,' + btoa(
                new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})